/* eslint-disable import/order */
import { uniqBy } from 'lodash'
import consola from 'consola'
import config from '@/cms.config'
import ApiClient from '../utils/api-client'
import { BaseResource as Resource } from '../defaults/resource'

const logger = consola.withTag('NuxtServerInit')

const getResources = async (axios, ctx, branch_id) => {
  logger.info('Getting resources for branch', branch_id)

  const client = new ApiClient(axios, ctx, branch_id)

  const response = await client.getResources()
  const resources = response && response.data.map((r) => { return { ...r, dirty: r.branch_id !== 1 } }) || []

  const filteredResources =  config.resourcesFilter && config.resourcesFilter(resources, ctx) || resources

  return uniqBy(filteredResources, 'path')
}

export const nuxtServerInit = async (store, ctx) => {
  const isCMS = ctx.query.cms && JSON.parse(ctx.query.cms)
  if (!isCMS) {
    // load website-role based contents
    const webClient = ctx.app.$axios
    webClient.setToken(`Bearer ${process.env.CMS_TOKEN}`)

    const resources = await getResources(webClient, ctx, Number(process.env.BRANCH_ID || 1))

    logger.log(`Inserting ${resources.length} resources into the store.`)

    await Resource.insertOrUpdate({ data: resources })
  }
}
